import pkg from '../../../package.json';

export const environment = {
  firebase: {
    apiKey: "AIzaSyC7gF8etXuvvOnktMK7OczDfag-8yZmuu8",
    authDomain: "signin.purple.fit",
    projectId: "purple-fit-app",
    storageBucket: "purple-fit-app.firebasestorage.app",
    messagingSenderId: "594637355848",
    appId: "1:594637355848:web:bc14d02da43feb8f70d17d",
    measurementId: "G-FMJY82EFM6"
  },

  appVersion: pkg.version,
  appName: pkg.name,
  production: false,
  DEFAULT_LANGUAGE: "it-it",  
  DEFAULT_PHONE_PREFIX: "+39",
  API_BASE_PATH: 'https://dev-api.purple.fit',
  CLIENT_ROUTE: 'purplefit',

  COMPANY_NAME: "PurpleFit",
  COMPANY_ABB: 'purplefit',
    
  HTML_THEME_COLOR: "#101722",
  HTML_TITLE_COLOR: "#101722",

  EDIT_TRAN_AFFIX: "webapp_",

  ROUTING_LOADER_DELAY: 250,
  API_CALL_LOADER_DELAY: 50,

  LOADER_ID: "global",
  LOADER_SPEED: 2,
  LOADER_DESKTOP_WIDTH: "500px",  
  LOADER_MOBILE_WIDTH: "260px",  
  
  PAYMENT_PROVIDER: "SumUp",
  
  SHOW_TAB_MENU_MOBILE: true,
  BROKER_ENABLED: true
};